var map = {
	"./klokantech.ts": [
		5323,
		323
	],
	"./osm-vector-tiles.ts": [
		4598,
		598
	],
	"./reunion-raster.ts": [
		5939,
		939
	],
	"./sync-init.ts": [
		4877,
		877
	],
	"./velivole.ts": [
		6959,
		959
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5916;
module.exports = webpackAsyncContext;